import React from 'react';
import { getChannelList } from 'api/channel';
import { Channel } from 'types/common';
import { getGoogleAuthStatus, getGoogleAuthUrl } from 'api/provider';

let globalData: string | undefined;

const useGoogleAuthUrl = (): [string | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [val, setVal] = React.useState<string | undefined>(globalData);
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getGoogleAuthUrl();
            if (!result.error) {
                const data: string = result?.data?.data?.authUrl || '';
                globalData = data;
                setVal(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!loading) {
            fetchData();
        }
    }, []);

    return [val, loading, fetchData];
};

export default useGoogleAuthUrl;
